import { Component, Input } from '@angular/core';
import { CLINICIAN_CANDIDATE_DOCUMENT_STATUS_META } from '../../../models/clinical-onboarding.model';

/**
 * DBEK-392 (audit UI/UX, item 7): badge di stato-documento, riusabile ovunque serva
 * mostrarlo - wizard clinico self-service (DBEK-405) e dialog di dettaglio clinico
 * (qui) lo reinventavano ciascuno con uno stile diverso, stesso problema gia' risolto
 * per il macro-stato in app-clinical-onboarding-status-badge (DBEK-403), di cui
 * questo componente e' la sorella.
 */
@Component({
  selector: 'app-clinical-onboarding-document-status-badge',
  templateUrl: './clinical-onboarding-document-status-badge.component.html',
  styleUrls: ['./clinical-onboarding-document-status-badge.component.scss'],
  standalone: false,
})
export class ClinicalOnboardingDocumentStatusBadgeComponent {
  @Input() status: string;

  readonly documentStatusMeta = CLINICIAN_CANDIDATE_DOCUMENT_STATUS_META;
}
